import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Image from 'react-bootstrap/Image';

const Header = () => (
  <Navbar expand='lg' sticky='top' className='app-navbar'>
    <Container>
      {/* Marca */}
      <Navbar.Brand as={Link} to='/' className='fw-bold d-flex align-items-center'>
        <Image
          src='/iconoApp.png'
          alt='Icono App'
          className='me-2'
          style={{ height: '2rem', width: 'auto' }}
        />
        <span className='fw-bold'>Proyecto Final</span>
      </Navbar.Brand>

      <Navbar.Toggle aria-controls='main-nav' />
      <Navbar.Collapse id='main-nav'>
        <Nav className='ms-auto'>
          <Nav.Link
            as={NavLink}
            to='/soil_analyses'
            className='px-3 fw-semibold'
          >
            Análisis de Suelo
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>
);

export default Header;
